import moment from 'moment';
import { TokenIcons, TxLinkIcon } from '../../../assets/icons';
import Card from '../../../components/Card';
import ExternalLink from '../../../components/ExternalLink';
import { CHAIN_INFO, EnabledChains, Tokens } from '../../../config/constants';
import { formatPercentages, formatUSD } from '../../../helpers';
import useCountdown from '../../../hooks/useCountdown';
import { useWeb3React } from '@web3-react/core';
import { UserLockedDeposit } from '../../../hooks/web3/pools/useUserLockedDeposits';

type LockedDepositProps = {
    deposit: UserLockedDeposit;
};

const LockedDeposit: React.FC<LockedDepositProps> = ({ deposit }) => {
    const { chainId } = useWeb3React();

    const { countDown } = useCountdown(
        deposit.unlockTime,
        ({ hours, minutes, seconds }, timeLeft) =>
            `${Math.floor(timeLeft.asDays())}d : ${hours}h : ${minutes}m : ${seconds}s`
    );

    return (
        <Card className='locked-deposit'>
            <div>
                <span className='label'>Date</span>
                <span>
                    {moment.unix(deposit.depositTimestamp).format('Do MMM YY, HH:mm:ss')}
                    <ExternalLink to={deposit.txHash}>
                        <TxLinkIcon />
                    </ExternalLink>
                </span>
            </div>
            <div>
                <span className='label'>Pool</span>
                <span>
                    {TokenIcons[deposit.liquidityPool.lpToken]}
                    {deposit.liquidityPool.name.split(' ')[0]}
                </span>
            </div>
            <div>
                <span className='label'>Type - Multiplier</span>
                <span>
                    {' '}
                    {deposit.lockUpType.duration === undefined
                        ? 'No Lock'
                        : `${deposit.lockUpType.duration} days`}
                    {' - '}
                    {formatPercentages(
                        deposit.lockUpType.feeMultiplier === undefined
                            ? 1
                            : deposit.lockUpType.feeMultiplier
                    )}
                    x
                </span>
            </div>
            <div>
                <span className='label'>Deposit</span>
                <span>
                    {TokenIcons[Tokens.USDC]}{' '}
                    {formatUSD(deposit.depositAmount, { minDecimals: 2 })}
                </span>
            </div>
            <div>
                <span className='label'>
                    Time Left
                    <span>&nbsp;-&nbsp;</span>
                </span>
                <span>
                    {moment.unix(deposit.unlockTime).isAfter(moment())
                        ? countDown
                        : 'Unlocked'}
                </span>
            </div>
            <ExternalLink
                to={`${CHAIN_INFO[chainId as EnabledChains[number]]?.blockExplorer}/tx/${
                    deposit.txHash
                }`}
            >
                <TxLinkIcon />
            </ExternalLink>
        </Card>
    );
};

export default LockedDeposit;
